import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setSelectedFilters, setBillsPagination} from '../actionCreators';
import $ from 'jquery';
import Datepicker from '../components/Datepicker'

class Filters extends Component {

    constructor(props){
	super(props);
	this.close = this.close.bind(this);
	this.assignCallback = this.assignCallback.bind(this);
	this.changeDateRangeHandler = this.changeDateRangeHandler.bind(this);
	this.changeExpirationDateRangeHandler = this.changeExpirationDateRangeHandler.bind(this);
	this.changeCreationDateRangeHandler = this.changeCreationDateRangeHandler.bind(this);
	this.changeBillCodeHandler = this.changeBillCodeHandler.bind(this);
	this.renderButtons = this.renderButtons.bind(this);
	this.renderUsersFilter = this.renderUsersFilter.bind(this);
	this.renderDateFilter = this.renderDateFilter.bind(this);
	this.changeUsersHandler = this.changeUsersHandler.bind(this);
	this.renderBillFilters = this.renderBillFilters.bind(this);
	this.renderReportsFilters = this.renderReportsFilters.bind(this);
	this.changeReportsDateRangeHandler = this.changeReportsDateRangeHandler.bind(this);
	this.changeReportOperationsHandler = this.changeReportOperationsHandler.bind(this);
	this.changeReportBillTypeHandler = this.changeReportBillTypeHandler.bind(this);
	this.renderBookingsFilters = this.renderBookingsFilters.bind(this);
	this.changeBookingsDateRangeHandler = this.changeBookingsDateRangeHandler.bind(this);
	
	this.state = {}
    }

	componentDidUpdate(prevProps, prevState) {
		if(Object.keys(this.state).length === 0 && this.props.selectedFilters.creation_date && this.props.selectedFilters.expiration_date){
			let creation_date = {}
			creation_date = JSON.parse(JSON.stringify(this.props.selectedFilters.creation_date))
			creation_date.start = new Date(creation_date.start)
			creation_date.end = new Date(creation_date.end)
			creation_date.active = this.props.selectedFilters.creation_date.active

			let expiration_date = {}
			expiration_date = JSON.parse(JSON.stringify(this.props.selectedFilters.expiration_date))
			expiration_date.start = new Date(expiration_date.start)
			expiration_date.end = new Date(expiration_date.end)
			expiration_date.active = this.props.selectedFilters.expiration_date.active

			let billCode = {}
			billCode = JSON.parse(JSON.stringify(this.props.selectedFilters.billCode))
			billCode.value = ''
			billCode.active = this.props.selectedFilters.billCode.active

			let reports_date = {}
			if(this.props.selectedFilters.reports_date){
				reports_date = JSON.parse(JSON.stringify(this.props.selectedFilters.reports_date))
				reports_date.start = new Date(reports_date.start)
				reports_date.end = new Date(reports_date.end)
				reports_date.active = this.props.selectedFilters.reports_date.active
			}
			
			this.setState(prevState => {
				return {
						...prevState,
						creation_date,
						expiration_date,
						billCode,
						reports_date
				}
			})
		}
	}

    close(){
	$("#filters-component").modal('toggle');
    }

    assignCallback(button){
	if(button.close && button.close) this.close();
	if(button.callback) button.callback();
    }

    render() {
    	return (
		<div className="modal fade" id="filters-component" tabIndex="-1" role="dialog" 
			aria-labelledby="ModalTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="ModalTitleLabel">
							{this.props.filtersContent && 
							this.props.filtersContent.title?this.props.filtersContent.title:''}
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<>
							{this.renderDateFilter()}
						</>
						<>
    							{this.renderUsersFilter()}
						</>
						<>
							{this.renderBillFilters()}
						</>
						<>
							{this.renderReportsFilters()}
						</>
						<>
							{this.renderBookingsFilters()}
						</>
					</div>
					<div className="modal-footer">
						{this.renderButtons()}
					</div>
				</div>
			</div>
		</div>
        )
    }

    renderDateFilter(){
	return this.props.filtersContent && this.props.filtersContent.dates?
		<>
		<div className="row mb-2">
			<div className="col-3">
				Fecha inicio
			</div>
			<div className="col-9">
				<Datepicker selected={this.props.filtersContent.dates.start} showTimeSelect={true} 
					name="start_date" className='form-control' onChange={this.changeDateRangeHandler}  />
			</div>
		</div>
		<div className="row mb-2">
			<div className="col-3">
				Fecha fin
			</div>
			<div className="col-9">
				<Datepicker selected={this.props.filtersContent.dates.end} showTimeSelect={true} 
					name="end_date" className='form-control' onChange={this.changeDateRangeHandler}  />
			</div>
		</div>
		</>
	:undefined

    }

    renderUsersFilter(){
	return this.props.filtersContent && this.props.filtersContent.users?
		<div className="row">
			<div className="col-3">
				Usuarios
			</div>
			<div className="col-9">
				<select className="form-control" multiple onChange={this.changeUsersHandler}>
					{this.props.filtersContent.users.map((usr,idx) => {
						return <option key={'filter_user_'+idx} value={usr._id}>{usr.name+' '+usr.lastname}</option>
					})}
				</select>
			</div>
		</div>
	:undefined
    }

    renderButtons(){
	return this.props.filtersContent && this.props.filtersContent.buttons?this.props.filtersContent.buttons.map( (button,idx) => {
		return (<button type="button" key={"modal_btn_"+idx}
			className={button.behaviour === 'main'?"btn btn-primary":"btn btn-secondary"} 
			data-dismiss={button.close === true?"modal":undefined}
			onClick={this.assignCallback.bind(this,button)}>
			{button.shown}
		</button>)
	}):''
    }

    changeUsersHandler(event){
    	const selectedUsers = Array.from(event.target.selectedOptions, option => option.value);
    	let selectedFilters = this.props.selectedFilters;
    	selectedFilters.users = selectedUsers;
		this.props.setSelectedFilters(selectedFilters);
    }

	changeCreationDateRangeHandler(date, input){
		if(input === undefined){
			input = date
			input = input.target
		}

		let selectedFilters = JSON.parse(JSON.stringify(this.state.creation_date));

    	let selectedDates = {
    		start: new Date(selectedFilters.start) , 
    		end: new Date(selectedFilters.end),
			active: true
    	};

		if(input.name === 'start_date'){
			selectedDates.start = date;
			
		}

		if(input.name === 'end_date'){
			selectedDates.end = date;
			
		}

		if(input.name === 'check_creation_date'){
			if(!input.checked){
				selectedDates.active = false
				
			}else{
				selectedDates.active = true
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				creation_date: selectedDates
			}
		})

		this.props.selectedFilters.creation_date = {
			start: new Date(JSON.parse(JSON.stringify(selectedDates.start))),
			end: new Date(JSON.parse(JSON.stringify(selectedDates.end))),
			active: JSON.parse(JSON.stringify(selectedDates.active))
		}

		const pagination = {
			totalItems: this.props.billsPagination?.totalItems??0,
			totalPages: this.props.billsPagination?.totalPages??1,
			currentPage: 1
		}

		this.props.setBillsPagination(pagination)
		this.props.setSelectedFilters(this.props.selectedFilters);
	}

	changeBillCodeHandler(e){
		const input = e.target

		let selectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters.billCode));

		let selectedCode = {
    		value: selectedFilters.value ,
			active: true
    	};

		if(input.name === 'billCode'){
			selectedCode.value = input.value
		}else{
			if(!input.checked){
				selectedCode.active = false
				
			}else{
				selectedCode.active = true
			}
		}

		this.props.selectedFilters.billCode = selectedCode

		this.props.setSelectedFilters(this.props.selectedFilters)

	}

	changeExpirationDateRangeHandler(date, input){
		if(input === undefined){
			input = date
			input = input.target
		}

		let selectedFilters = JSON.parse(JSON.stringify(this.state.expiration_date));

    	let selectedDates = {
    		start: new Date(selectedFilters.start) , 
    		end: new Date(selectedFilters.end),
			active: true
    	};

		if(input.name === 'start_date'){
			selectedDates.start = date;
			
		}

		if(input.name === 'end_date'){
			selectedDates.end = date;
			
		}

		if(input.name === 'check_expiration_date'){
			if(!input.checked){
				selectedDates.active = false
				
			}else{
				selectedDates.active = true
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				expiration_date: selectedDates
			}
		})

		const pagination = {
			totalItems: this.props.billsPagination?.totalItems??0,
			totalPages: this.props.billsPagination?.totalPages??1,
			currentPage: 1
		}

		this.props.setBillsPagination(pagination)
		
		this.props.selectedFilters.expiration_date = {
			start: new Date(JSON.parse(JSON.stringify(selectedDates.start))),
			end: new Date(JSON.parse(JSON.stringify(selectedDates.end))),
			active: JSON.parse(JSON.stringify(selectedDates.active))
		}

		this.props.setSelectedFilters(this.props.selectedFilters);
	}


    changeDateRangeHandler(date, input){

		let selectedFilters = this.props.selectedFilters;

    	let selectedDates = {
    		start: this.props.selectedFilters.dateRange.start , 
    		end: this.props.selectedFilters.dateRange.end
    	};

		if(input.name === 'start_date'){
			selectedDates.start = date;
		}

		if(input.name === 'end_date'){
			selectedDates.end = date;
		}

    	selectedFilters.dateRange = selectedDates;
		this.props.setSelectedFilters(selectedFilters);
    }


	renderBillFilters(){

		const checkCreationDate = (this.state.creation_date && this.state.creation_date.active) || 
									(this.props.selectedFilters.creation_date && this.props.selectedFilters.creation_date.active)?true:false
		const checkExpirationDate = (this.state.expiration_date && this.state.expiration_date.active) || 
									(this.props.selectedFilters.expiration_date && this.props.selectedFilters.expiration_date.active)?true:false
		const checkBillCode = (this.state.billCode && this.state.billCode.active) || 
									(this.props.selectedFilters.billCode && this.props.selectedFilters.billCode.active)?true:false

		return (
			<>
			{this.props.filtersContent && this.props.filtersContent.billCode?
			<div className="row mb-2">
				<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
					<input name="check_billCode" defaultChecked={checkBillCode=== true?'checked': undefined}
						type="checkbox" onChange={this.changeBillCodeHandler} />
				</div>
				<div className="col-11">
					<div className="row mb-2">
						<div className="col-6">
							Código de factura
						</div>
						<div className="col-4">
							<input type="text" defaultValue={this.state.billCode?.value} 
								id="billCode"
								name="billCode" className='form-control' onChange={this.changeBillCodeHandler}  />
						</div>
					</div>
				</div>
			</div>
			:undefined}
			{this.props.filtersContent && this.props.filtersContent.creation_date?
			<div className="row mb-2">
				<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
					<input name="check_creation_date" defaultChecked={checkCreationDate=== true?'checked': undefined}
					type="checkbox" onChange={this.changeCreationDateRangeHandler} />
				</div>
				<div className="col-11">
					<div className="row mb-2">
						<div className="col-6">
							Fecha creación inicio
						</div>
						<div className="col-4">
							<Datepicker selected={this.state.creation_date?.start} dateFormat="dd/MM/yyyy"
								style={{width:"100px"}} showTimeSelect={undefined}
								id="creation_date_start"
								name="start_date" className='form-control' onChange={this.changeCreationDateRangeHandler}  />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-6">
							Fecha creación fin
						</div>
						<div className="col-4">
							<Datepicker selected={this.state.creation_date?.end} dateFormat="dd/MM/yyyy"
							showTimeSelect={undefined}
								id="creation_date_end"
								name="end_date" className='form-control' onChange={this.changeCreationDateRangeHandler}  />
						</div>
					</div>
				</div>
			</div>
			:undefined}
			{this.props.filtersContent && this.props.filtersContent.expiration_date?
			<div className="row mb-2">
				<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
					<input name="check_expiration_date" defaultChecked={checkExpirationDate=== true?'checked': undefined}
						type="checkbox" onChange={this.changeExpirationDateRangeHandler} />
				</div>
				<div className="col-11">
					<div className="row mb-2">
						<div className="col-6">
							Fecha vencimiento inicio
						</div>
						<div className="col-4">
							<Datepicker selected={this.state.expiration_date?.start} dateFormat="dd/MM/yyyy"
								id="expiration_date_start"
								name="start_date" className='form-control' onChange={this.changeExpirationDateRangeHandler}  />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-6">
							Fecha vencimiento fin
						</div>
						<div className="col-4">
							<Datepicker selected={this.state.expiration_date?.end} dateFormat="dd/MM/yyyy"
							showTimeSelect={undefined}
								id="expiration_date_end"
								name="end_date" className='form-control' onChange={this.changeExpirationDateRangeHandler}  />
						</div>
					</div>
				</div>
			</div>
			:undefined}
			</>
		)
	}

	changeReportsDateRangeHandler(date, input){
		if(input === undefined){
			input = date
			input = input.target
		}

		let selectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters.reports_date));

    	let selectedDates = {
    		start: new Date(selectedFilters.start), 
    		end: new Date(selectedFilters.end),
			active: true
    	};

		if(input.name === 'start_date'){
			selectedDates.start = date;
			
		}

		if(input.name === 'end_date'){
			selectedDates.end = date;
			
		}

		if(input.name === 'check_reports_date'){
			if(!input.checked){
				selectedDates.active = false
				
			}else{
				selectedDates.active = true
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				reports_date: selectedDates
			}
		})

		this.props.selectedFilters.reports_date = {
			start: new Date(JSON.parse(JSON.stringify(selectedDates.start))),
			end: new Date(JSON.parse(JSON.stringify(selectedDates.end))),
			active: JSON.parse(JSON.stringify(selectedDates.active))
		}

		let newSelectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters))		
		newSelectedFilters.reports_date.start =  new Date(newSelectedFilters.reports_date.start)
		newSelectedFilters.reports_date.end =  new Date(newSelectedFilters.reports_date.end)

		this.props.setSelectedFilters(newSelectedFilters); //this.props.selectedFilters);
	}

	changeReportOperationsHandler(event){
    	
    	let newSelectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters))	
		newSelectedFilters.reports_date.start =  new Date(newSelectedFilters.reports_date.start)
		newSelectedFilters.reports_date.end =  new Date(newSelectedFilters.reports_date.end)

		if(event.target.name === 'operations'){
			const selectedOperations = Array.from(event.target.selectedOptions, option => option.value)

    		newSelectedFilters.operations = {
				collection: selectedOperations,
				active: this.props.selectedFilters.operations.active
			}
		}else{
			if(!event.target.checked){
				newSelectedFilters.operations.active = false
				
			}else{
				newSelectedFilters.operations.active = true
			}
		}
		this.props.setSelectedFilters(newSelectedFilters);
    }

	changeReportBillTypeHandler(event){
    	let newSelectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters))	
		newSelectedFilters.reports_date.start =  new Date(newSelectedFilters.reports_date.start)
		newSelectedFilters.reports_date.end =  new Date(newSelectedFilters.reports_date.end)

		if(event.target.name === 'billType'){
			const selectedBillTypes = Array.from(event.target.selectedOptions, option => option.value)

    		newSelectedFilters.billType = {
				collection: selectedBillTypes,
				active: this.props.selectedFilters.billType.active
			}
		}else{
			if(!event.target.checked){
				newSelectedFilters.billType.active = false
				
			}else{
				newSelectedFilters.billType.active = true
			}
		}
		this.props.setSelectedFilters(newSelectedFilters);
    }

	changeBookingsDateRangeHandler(date, input){
		if(input === undefined){
			input = date
			input = input.target
		}

		let selectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters.bookings_date));

    	let selectedDates = {
    		start: new Date(selectedFilters.start), 
    		end: new Date(selectedFilters.end),
			active: true
    	};

		if(input.name === 'start_date'){
			selectedDates.start = date;
			
		}

		if(input.name === 'end_date'){
			selectedDates.end = date;
			
		}

		if(input.name === 'check_bookings_date'){
			if(!input.checked){
				selectedDates.active = false
				
			}else{
				selectedDates.active = true
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				bookings_date: selectedDates
			}
		})

		this.props.selectedFilters.bookings_date = {
			start: new Date(JSON.parse(JSON.stringify(selectedDates.start))),
			end: new Date(JSON.parse(JSON.stringify(selectedDates.end))),
			active: JSON.parse(JSON.stringify(selectedDates.active))
		}

		let newSelectedFilters = JSON.parse(JSON.stringify(this.props.selectedFilters))		
		newSelectedFilters.bookings_date.start =  new Date(newSelectedFilters.bookings_date.start)
		newSelectedFilters.bookings_date.end =  new Date(newSelectedFilters.bookings_date.end)

		this.props.setSelectedFilters(newSelectedFilters); //this.props.selectedFilters);
	}

	renderReportsFilters(){
		const checkReportsDate = (this.state.reports_date && this.state.reports_date.active) || 
									(this.props.selectedFilters.reports_date && this.props.selectedFilters.reports_date.active)?true:false

		const checkOperations = (this.state.operations && this.state.operations.active) || 
									(this.props.selectedFilters.operations && this.props.selectedFilters.operations.active)?true:false

		const checkBillType = (this.state.billType && this.state.billType.active) || 
									(this.props.selectedFilters.billType && this.props.selectedFilters.billType.active)?true:false
		return (
			<>
				{this.props.filtersContent && this.props.filtersContent.reports_date?
				<div className="row mb-2">
					<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
						<input name="check_reports_date" defaultChecked={checkReportsDate=== true?'checked': undefined}
						type="checkbox" onChange={this.changeReportsDateRangeHandler} />
					</div>
					<div className="col-11">
						<div className="row mb-2">
							<div className="col-6">
								Fecha informe inicio
							</div>
							<div className="col-4">
								<Datepicker selected={this.props.selectedFilters.reports_date?.start} dateFormat="dd/MM/yyyy"
									style={{width:"100px"}} showTimeSelect={undefined}
									id="reports_date_start"
									name="start_date" className='form-control' onChange={this.changeReportsDateRangeHandler}  />
							</div>
						</div>
						<div className="row mb-2">
							<div className="col-6">
								Fecha informe fin
							</div>
							<div className="col-4">
								<Datepicker selected={this.props.selectedFilters.reports_date?.end} dateFormat="dd/MM/yyyy"
								showTimeSelect={undefined}
									id="reports_date_end"
									name="end_date" className='form-control' onChange={this.changeReportsDateRangeHandler}  />
							</div>
						</div>
					</div>
				</div>
				:undefined}

				{this.props.filtersContent && this.props.filtersContent.operations?.collection?.length > 0?
				<div className="row mb-2">
					<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
						<input name="check_operations" defaultChecked={checkOperations=== true?'checked': undefined}
						type="checkbox" onChange={this.changeReportOperationsHandler} />
					</div>
					<div className="col-11">
						<div className="row mb-2">
							<div className="col-6 mt-2">
								Tipos de operación
							</div>
							<div className="col-6">
								<select  selected={this.props.selectedFilters.operations?.collection} 
									id="operations" name="operations" className='form-control' 
									multiple
									onChange={this.changeReportOperationsHandler}>
									{this.props.filtersContent.operations?.collection?.map(opt => {
										return <option key={'operation_'+opt._id} value={opt._id}>{opt.name}</option>
									})}
								</select>
							</div>
						</div>
					</div>
				</div>
				:undefined}
				{this.props.filtersContent && this.props.filtersContent.billType?
				<div className="row mb-2">
					<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
						<input name="check_billType" defaultChecked={checkBillType=== true?'checked': undefined}
						type="checkbox" onChange={this.changeReportBillTypeHandler} />
					</div>
					<div className="col-11">
						<div className="row mb-2">
							<div className="col-6 mt-2">
								Tipos de factura
							</div>
							<div className="col-6">
								<select  selected={this.props.selectedFilters.billType?.collection} 
									id="billType" name="billType" className='form-control' 
									multiple
									onChange={this.changeReportBillTypeHandler}>
									{this.props.filtersContent.billType?.collection?.map(opt => {
										return <option key={'billType_'+opt._id} value={opt._id}>{opt.name}</option>
									})}
								</select>
							</div>
						</div>
					</div>
				</div>
				:undefined}

			</>
		)
	}

	renderBookingsFilters(){
		const checkBookingsDate = (this.state.bookings_date && this.state.bookings_date.active) || 
									(this.props.selectedFilters.bookings_date && this.props.selectedFilters.bookings_date.active)?true:false

		return (
			<>
			{this.props.filtersContent && this.props.filtersContent.bookings_date?
				<>
				<div className="row ml-3 mb-2">
					<div className="col-12">Este filtro aplica a la fecha fin de reserva</div>
				</div>
				<div className="row mb-2">
					<div className="col-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
						<input name="check_bookings_date" defaultChecked={checkBookingsDate=== true?'checked': undefined}
						type="checkbox" onChange={this.changeBookingsDateRangeHandler} />
					</div>
					<div className="col-11">
						<div className="row mb-2">
							<div className="col-6">
								Fecha reservas inicio
							</div>
							<div className="col-4">
								<Datepicker selected={this.props.selectedFilters.bookings_date?.start} dateFormat="dd/MM/yyyy"
									style={{width:"100px"}} showTimeSelect={undefined}
									id="bookings_date_start"
									name="start_date" className='form-control' onChange={this.changeBookingsDateRangeHandler}  />
							</div>
						</div>
						<div className="row mb-2">
							<div className="col-6">
								Fecha reservas fin
							</div>
							<div className="col-4">
								<Datepicker selected={this.props.selectedFilters.bookings_date?.end} dateFormat="dd/MM/yyyy"
								showTimeSelect={undefined}
									id="bookings_date_end"
									name="end_date" className='form-control' onChange={this.changeBookingsDateRangeHandler}  />
							</div>
						</div>
					</div>
				</div>
				</>
			:undefined}
			</>
		)
	}
}

const mapStateToProps = state => {
    return {
        filtersContent: state.filtersContent,
        selectedFilters: state.selectedFilters,
		billsPagination: state.billsPagination
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedFilters(selectedFilters){
            dispatch(setSelectedFilters(selectedFilters));
        },
		setBillsPagination(pagination){
			dispatch(setBillsPagination(pagination));
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters)
